import { toStrictISOString } from '../../helpers/string'
import { NotificationCenterLog, NotificationCenterResource } from './NotificationCenter'

export const notificationCenterTransformer = (resource: NotificationCenterResource): NotificationCenterLog => ({
    uuid: resource.uuid,
    action: resource.action,
    category: resource.category,
    tags: resource.tags,
    currentUserName: toStrictISOString(resource.currentUserName),
})
